<template>
  <lottie-player
    v-if="files[content] && !staticAnimation"
    :src="files[content]"
    background="transparent"
    :speed="speed"
    :loop="loop"
    autoplay
  ></lottie-player>
  <lottie-player
    v-else-if="files[content] && staticAnimation"
    :src="files[content]"
    background="transparent"
  ></lottie-player>
</template>

<script>
import { defineComponent } from "vue";
import emptyTransactions from "../../assets/lotties/empty_state.json";
import download from "../../assets/lotties/arrowDown.json";
import gift from "../../assets/lotties/gift.json";
import rocket from "../../assets/lotties/rocket.json";

export default defineComponent({
  name: "LottieComponent",
  props: {
    loop: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    speed: {
      type: String,
      default: "1",
    },
    animationDuration: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      staticAnimation: false,
      files: {
        emptyTransactions: JSON.stringify(emptyTransactions),
        download: JSON.stringify(download),
        gift: JSON.stringify(gift),
        rocket: JSON.stringify(rocket),
      },
    };
  },
  mounted() {
    this.controllAnimationDuration();
  },
  methods: {
    controllAnimationDuration() {
      if (!this.animationDuration) return;
      setTimeout(() => {
        this.staticAnimation = true;
      }, this.animationDuration);
    },
  },
  computed: {},
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
